import React from "react";
import ParentSize from "@visx/responsive/lib/components/ParentSize";
import { XYChart, BarSeries, Axis, Grid, Tooltip } from "@visx/xychart";

const accessors = {
  xAccessor: (d) => d.section,
  yAccessor: (d) => d.value,
};

export default function SectionComparisonChart({ sections = [] }) {
  const chartData = sections.flatMap((s) => [
    { section: s.label, series: "Your org", value: s.orgScore || 0, color: s.color },
    { section: s.label, series: "Benchmark", value: s.benchmarkScore || 0, color: "#94a3b8" },
  ]);

  if (!sections.length) {
    return <p style={{ color: "#6b7280", fontSize: "0.85rem" }}>No section scores available.</p>;
  }

  return (
    <ParentSize>
      {({ width, height }) =>
        width > 0 && (
          <XYChart
            height={Math.max(height, 260)}
            width={width}
            xScale={{ type: "band", padding: 0.3 }}
            yScale={{ type: "linear", domain: [0, 100], nice: true }}
            margin={{ top: 16, right: 16, bottom: 48, left: 44 }}
          >
            <Grid columns={false} numTicks={5} lineStyle={{ stroke: "#f3f4f6" }} />
            <Axis orientation="left" numTicks={5} tickLabelProps={() => ({ fontSize: 10, fill: "#6b7280" })} />
            <Axis orientation="bottom" tickLabelProps={() => ({ fontSize: 9, fill: "#6b7280", angle: -20, textAnchor: "end", dy: "0.25em" })} />
            <BarSeries
              dataKey="org"
              data={chartData.filter((d) => d.series === "Your org")}
              {...accessors}
              colorAccessor={() => "#02b880"}
            />
            <BarSeries
              dataKey="bench"
              data={chartData.filter((d) => d.series === "Benchmark")}
              {...accessors}
              colorAccessor={() => "#cbd5e1"}
            />
            <Tooltip
              snapTooltipToDatumX
              snapTooltipToDatumY
              renderTooltip={({ tooltipData }) => (
                <div style={{ background: "#fff", border: "1px solid #e5e7eb", padding: "8px 10px", borderRadius: 8, fontSize: 12 }}>
                  <strong>{tooltipData?.nearestDatum?.datum?.section}</strong>
                  <div>Score: {tooltipData?.nearestDatum?.datum?.value?.toFixed(1)}</div>
                </div>
              )}
            />
          </XYChart>
        )
      }
    </ParentSize>
  );
}
